module.exports = __webpack_public_path__ + "media/images/common/print_btn_l_ov-9918ad5011e3e3c764352987a5c11819.png";